import { TBColumn } from "../../../interfaces/TableBits.interfaces";

const columns: TBColumn[] = [
  {
    id: "Collaborator",
    label: "Nombre",
    align: "left",
    width: 300,
  },
  {
    id: "dateOfAdmission",
    label: "Fecha inicial",
    align: "left",
    width: 150,
  },
  {
    id: "FechaBaja",
    label: "Fecha final",
    align: "left",
    width: 150,
  },
  {
    id: "contractStatus",
    label: "Estatus",
    align: "left",
    width: 100,
  },
  {
    id: "days",
    label: "Días",
    align: "left",
    width: 150,
  },
];
export default columns;
